/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {null|Element}  Returns null if not match found
 * https://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/
 */

export default function getClosest(elem: HTMLElement, selector: string): null | HTMLElement {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {
          var t = i;
        }
        return i > -1;
      };
  }
  // Get closest match
  for (; elem && elem !== document.documentElement; elem = elem.parentNode as HTMLElement) {
    if (elem.matches(selector)) return elem;
  }
  return null;
}
